import axios from "axios";
import React, { useState, useEffect } from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useParams, Redirect } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { API_URL, NEW_API_URL } from "../../../constants/Globals";
import { connect } from "react-redux";
import useDebounce from "../../../hooks/useDebounce";
import Autosuggest from "react-autosuggest";
import NetworksSelector from "../../NetworksSelector";
var moment = require("moment-timezone");

const AddEditCampaign = ({ selNetworkId, allNetworks = [], groups = [] }) => {
  const [id, setId] = useState(useParams().id);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  // const [debateId, setDebateId] = useState("");
  // const [debateTitle, setDebateTitle] = useState("");
  // const [formId, setFormId] = useState(null);
  // const [sequenceId, setSequenceId] = useState(null);
  const [cTypeId, setCTypeId] = useState("");
  const [cTypeTitle, setCTypeTitle] = useState("");
  const [responseCountTarget, setResponseCountTarget] = useState(100);
  const [contentTypeValue, setContentTypeValue] = useState("Poll");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [scope, setScope] = useState("All Sites");
  const [isRecordSaved, setIsRecordSaved] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  // const [pollList, setPollList] = useState([]);
  const [ctContentList, setCtContentList] = useState([]);
  const [forNetworks, setForNetworks] = useState([]);
  const [isClosed, setIsClosed] = useState(false);
  const [responseList, setResponseList] = useState([
    1, 5, 10, 50, 100, 200, 300, 400, 500, 1000, 2000, 5000, 10000,
  ]);
  const [slotNumberList, setSlotNumberList] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ]);
  const [slotNumber, setSlotNumber] = useState(1);
  const [campaignScope, setCampaignScope] = useState([
    "All Sites",
    "Specific Sites",
  ]);
  const [contentTypesList, setContentTypesList] = useState([
    "Poll", "Sequence"
  ]);
  // const endedAtMinDate = moment().add(5, "minutes");
  const kTrans = (str) => str;
  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));
  };

  useEffect(() => {
    if (id > 0) {
      axios.get(`${NEW_API_URL}/campaigns/${id}`).then(({ data }) => {
        const response = data;
        setId(response.data.id);
        setTitle(response.data.title);
        setDescription(response.data.description);
        setResponseCountTarget(response.data.responseCountTarget);
        setSlotNumber(response.data.slotNumber);
        setStartDate(moment(response.data.startDate));
        setEndDate(moment(response.data.endDate));
        if (response.data.forNetworks.length > 0) {
          setScope("Specific Sites");
        } else {
          setScope("All Sites");
        }
        if (response.data.debateId != null) {
          setContentTypeValue("Poll");
          setCTypeId(response.data.debateId);
          setCTypeTitle(response.data.campaignDebate?.thesis ?? "");
          setSearchInput(response.data.campaignDebate?.thesis ?? "");
        } else if (response.data.sequenceId) {
          setContentTypeValue("Sequence");
          setCTypeId(response.data.sequenceId);
          setCTypeTitle(response.data.campaignSequence?.name ?? "");
          setSearchInput(response.data.campaignSequence?.name ?? "");
        }
        
        //setSearchInput(response.data.campaignDebate?.contentTypeDesc ?? "");
        setForNetworks(response.data.forNetworks, []);
        setIsClosed(response.data.isClosed);
        console.log(response.data);
      });
    } else {
      setStartDate(moment());
      setEndDate(moment().add(7, "days"));
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (title.trim() === "") {
      alert("Please enter campaign title.");
      return false;
    }
    // if (debateId === "") {
    //   alert("Please select a poll.");
    //   return false;
    // }
    if (cTypeId === "") {
      alert("Please select a poll, quiz or sequence.");
      return false;
    }
    let campDebateId = null;
    let campSequenceId = null;
    let campFormId = null;
    if (contentTypeValue === "Poll") {
      campDebateId = cTypeId;
    } else if (contentTypeValue === "Sequence") {
      campSequenceId = cTypeId;
    } else {
      alert("Not a valid type.");
      return false;
    }
    if (startDate === null) {
      alert("Please select start date.");
      return false;
    }
    if (endDate === null) {
      alert("Please select end date.");
      return false;
    }
    if (startDate.isAfter(endDate)) {
      alert("Start date must be before end date.");
      return false;
    }
    if (scope === "Specific Sites" && forNetworks.length === 0) {
      alert("Please select sites.");
      return false;
    }
    
    try {
      const url =
        id > 0 ? `${NEW_API_URL}/campaigns/${id}` : `${NEW_API_URL}/campaigns`;
      const method = id > 0 ? "PUT" : "POST";
      axios
        .request({
          url,
          method,
          data: {
            id: id,
            title: title,
            description: description,
            debateId: campDebateId,
            formId: campFormId,
            sequenceId: campSequenceId,
            responseCountTarget: responseCountTarget,
            startDate: startDate,
            endDate: endDate,
            runFor: "networks",
            forNetworks: scope == "All Sites" ? [] : forNetworks,
            responseCount: 0,
            slotNumber: slotNumber,
          },
        })
        .then(({ data }) => {
          const response = data;
          setScope("All Sites");
          console.log(response.data);
          setIsRecordSaved(true);
        });
    } catch (error) {
      console.error("Error saving campaign:", error);
    }
  };

  const handleResponseDropdownChange = async (e, response) => {
    e.preventDefault();
    setResponseCountTarget(response);
  };

  const handleContentTypeDDChange = async (e, response) => {
    e.preventDefault();
    setCTypeTitle("");
    setCTypeId("");
    setSearchInput("");
    setContentTypeValue(response);
  }
  const handleSlotNumberDropdownChange = async (e, response) => {
    e.preventDefault();
    response === "N/A" ? setSlotNumber(null) : setSlotNumber(response);
  };

  const handleScopeDropdownChange = async (e, response) => {
    e.preventDefault();
    setScope(response);
  };

  const handlePollSearchOnChange = (event) => {
    setSearchInput(event.target.value);
  };

  const searchPolls = async () => {
    if (debouncedSearch !== cTypeTitle) {
      if (contentTypeValue === "Poll") {
        axios
        .get(
          API_URL +
            `/admin/debate/getDebates?isActive=1&perPage=5&pageNumber=1&clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}`
        ).then(({ data }) => setCtContentList(data.data.rows));
      } else if (contentTypeValue === "Sequence") {
        axios
        .get(
          API_URL +
            `/collections?clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}`
        ).then(({ data }) => setCtContentList(data.data));
      }
    }
  };

  const debouncedSearch = useDebounce(searchInput, 500);
  const handleDropdownSelect = async (selectedPoll) => {
    setCTypeId(selectedPoll.id);
    setCTypeTitle(selectedPoll.contentTypeDesc);
  };

  useEffect(() => {
    if (debouncedSearch) searchPolls();
  }, [debouncedSearch]);

  const onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSearchInput(value);
    // searchPolls();
  };

  const onSuggestionsClearRequested = () => {
    setCtContentList([]);
  };

  if (isRecordSaved) {
    return <Redirect to="/campaigns" />;
  }

  return (
    <div className="segments">
      <div className="page-headline is-flex">
        <div>
          <strong>Advertising</strong>&nbsp;|&nbsp;
          {id == "0" ? "Add New Campaign" : "Edit Campaign"}
          {isClosed ? " (Closed)" : ""}
        </div>
      </div>
      <div className="add-edit-campaign">
        <Form onSubmit={handleSubmit} className="common-form sided-form">
          <Form.Group className="border-bottom pb-4">
            <Form.Label>
              <b className="text-sm-start">{kTrans("Name this campaign")}</b>
            </Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              id="title"
              name="title"
              className="w-50"
              placeholder={kTrans("Enter the user's name")}
              disabled={isClosed}
            />
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <Form.Label>
              <b className="text-sm-start">
                {kTrans("Select content type")}
              </b>
            </Form.Label>
            <DropdownButton
              className="customDropdown w-25"
              id="contentType"
              title={
                contentTypesList.find((item) => item === contentTypeValue) ??
                "N/A"
              }
              disabled={isClosed}
              // onChange={(e) => handleChange(e)}
            >
              {contentTypesList && contentTypesList.length ? (
                contentTypesList.map((el, i) => (
                  <Dropdown.Item
                    key={i}
                    name="contentType"
                    onClick={(e) => handleContentTypeDDChange(e, el)}
                    as="button"
                  >
                    {el}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item>No responses available</Dropdown.Item>
              )}
            </DropdownButton>
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <Form.Check.Label>
              <b className="text-sm-start">
                {kTrans("Select a poll, quiz, or sequence")}
              </b>
            </Form.Check.Label>
            <Autosuggest
              suggestions={ctContentList}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              getSuggestionValue={(suggestion) => suggestion}
              renderSuggestion={(suggestion) => (
                <span className="customLabel">{suggestion.contentTypeDesc}</span>
              )}
              inputProps={{
                placeholder: "Type a description",
                value: searchInput,
                className: "w-50 form-control",
                // disabled: { isClosed },
                onBlur: (e) => {
                  setSearchInput(cTypeTitle ?? "");
                },
                onChange: (e, { newValue }) => {
                  console.log("onChange Poll: ", newValue);
                  if (newValue && (newValue.contentTypeDesc || newValue.id)) {
                    setContentTypeValue(contentTypeValue);
                    setCTypeTitle(newValue.contentTypeDesc);
                    setCTypeId(newValue.id);
                    setSearchInput(newValue.contentTypeDesc);
                    e.preventDefault();
                  } else {
                    setSearchInput(e.target.value);
                  }
                },
              }}
              theme={{
                input: "form-control",
                // suggestionsContainer: "border mt-1 pt-2",
                suggestionsList: "list-group font-size-sm",
                suggestion: "list-group-item",
                suggestionHighlighted: "active",
              }}
            />
            {/* <span className="customLabel">
              {debateId ? debateId : "No poll selected"}
            </span> */}
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <Form.Check.Label>
              <b className="text-sm-start">
                {kTrans("Where would you like your campaign to run?")}
              </b>
            </Form.Check.Label>
            <div style={{ display: "flex" }}>
              <DropdownButton
                className="customDropdown w-25 me-3 standard-dropdown"
                id="scope"
                title={campaignScope.find((item) => item === scope) ?? "N/A"}
                disabled={isClosed}
                // onChange={(e) => handleChange(e)}
              >
                {campaignScope && campaignScope.length ? (
                  campaignScope.map((el, i) => (
                    <Dropdown.Item
                      key={i}
                      name="scope"
                      onClick={(e) => handleScopeDropdownChange(e, el)}
                      as="button"
                    >
                      {el}
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item>No scope available</Dropdown.Item>
                )}
              </DropdownButton>

              {scope === "Specific Sites" && (
                <NetworksSelector
                  defaultText="Select Sites"
                  multiple={true}
                  value={forNetworks}
                  onChange={(e) => {
                    // e.preventDefault();
                    console.log("NetworksSelector: ", e);
                    setForNetworks(e);
                    return false;
                  }}
                  networks={allNetworks}
                  isShowTitle={false}
                  preventSubmit={true}
                />
              )}
            </div>

            <label className="mt-3 text-muted font-weight-normal">
              Estimated react: 75,000 people
            </label>
          </Form.Group>

          <Form.Group className="border-bottom py-2">
            <div style={{ display: "flex" }}>
              <div className="d-flex flex-column">
                <Form.Label>
                  <b className="text-sm-start">
                    {kTrans("How many responses you want?")}
                  </b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30"
                  id="responseCountTarget"
                  title={
                    responseList.find((item) => item === responseCountTarget) ??
                    "N/A"
                  }
                  disabled={isClosed}
                  // onChange={(e) => handleChange(e)}
                >
                  {responseList && responseList.length ? (
                    responseList.map((el, i) => (
                      <Dropdown.Item
                        key={i}
                        name="responseCountTarget"
                        onClick={(e) => handleResponseDropdownChange(e, el)}
                        as="button"
                      >
                        {el}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item>No responses available</Dropdown.Item>
                  )}
                </DropdownButton>
              </div>
              <div className="d-flex flex-column">&nbsp;&nbsp;&nbsp;&nbsp;</div>
              <div className="d-flex flex-column">
                <Form.Label>
                  <b className="text-sm-start">
                    {kTrans("Position of Poll in embed feed")}
                  </b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30"
                  id="slotNumber"
                  title={
                    slotNumberList.find((item) => item === slotNumber) ?? ""
                  }
                  disabled={isClosed}
                  // onChange={(e) => handleChange(e)}
                >
                  {slotNumberList && slotNumberList.length ? (
                    slotNumberList.map((el, i) => (
                      <Dropdown.Item
                        key={i}
                        name="slotNumber"
                        onClick={(e) => handleSlotNumberDropdownChange(e, el)}
                        as="button"
                      >
                        {el}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item>No responses available</Dropdown.Item>
                  )}
                </DropdownButton>
              </div>
            </div>
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <div
              className="inline-content top"
              style={{ justifyContent: "start" }}
            >
              <Form.Group controlId="startDate" className="me-3">
                <Form.Label>Start Date </Form.Label>
                <div className="datePickerWrapper">
                  {startDate !== null ? (
                    <>
                      <DateRangePicker
                        onCallback={(e) => {
                          console.log("start date: ", e);
                          setStartDate(e);
                        }}
                        initialSettings={{
                          singleDatePicker: true,
                          // minDate: moment(),
                          startDate: startDate,
                          timePicker: true,
                          locale: {
                            format: "MM/DD/YY @ hh:mmA",
                          },
                        }}
                        disabled={isClosed}
                      >
                        <input
                          type="text"
                          name="startDate"
                          className="form-control datepickerField"
                          disabled={isClosed}
                        />
                      </DateRangePicker>
                      <i className="fa fa-calendar"></i>
                    </>
                  ) : null}
                </div>
              </Form.Group>
              <Form.Group controlId="endDate" className="">
                <Form.Label>End Date</Form.Label>
                <div className="datePickerWrapper">
                  {endDate !== null ? (
                    <>
                      <DateRangePicker
                        onCallback={(e) => setEndDate(e)}
                        initialSettings={{
                          singleDatePicker: true,
                          // minDate: endedAtMinDate,
                          startDate: endDate["_d"],
                          /*maxDate: endedAtMaxDate,*/
                          timePicker: false,
                          locale: {
                            format: "MM/DD/YY @ hh:mmA",
                          },
                        }}
                        disabled={isClosed}
                      >
                        <input
                          type="text"
                          name="endDate"
                          className={`form-control datepickerField`}
                          disabled={isClosed}
                        />
                      </DateRangePicker>
                      <i className="fa fa-calendar"></i>
                    </>
                  ) : null}
                </div>
              </Form.Group>
            </div>
          </Form.Group>
          <div className="d-flex pt-4">
            <button
              type="submit"
              className="blue-button size-l"
              disabled={isClosed}
            >
              {id > 0 ? "Update Campaign" : "Create Campaign"}
            </button>
            <Link to="/campaigns" className="btn btn-link">
              Cancel
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
  allNetworks: state.networks.networksList,
  groups: state.networks.groupsList,
});

export default connect(mapStateToProps)(AddEditCampaign);
